import React, { useEffect, useState } from "react";
import {  MISformP1, MISformP10, MISformP11, MISformP12, MISformP13, MISformP14, MISformP15, MISformP16, MISformP17, MISformP18, MISformP19, MISformP2, MISformP20, MISformP21, MISformP22, MISformP23, MISformP24, MISformP25, MISformP26, MISformP3, MISformP4, MISformP5, MISformP6, MISformP7, MISformP8, MISformP9  } from "../../core/data/json/MIS_Forms";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ApplicationTimelineModal from "../application/ApplicationTimeLineModal";
import { getOneMISApplicationDetails, submitApproveRejectMISApplication } from "../auth/services/privateapicalling";
import { useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
 
const APP_STATUS_LEVEL_MAP: { [key: string]: string } = {
  // From transaction data
  "clerkAfterApproveAction": "Junior Clerk",
  "pendingAtDrResubmission": "District Registrar",
  "pendingAtCoResubmission": "Cooperative Officer Marketing",
  "pendingAtClerkResubmission": "Junior Clerk",
  "pendingAtApmcSecretaryResubmission": "Secretary",
  "clerkAfterRejectionAction": "Junior Clerk",
  "pendingAtDr": "District Registrar",
  "pendingAtCo": "Cooperative Officer Marketing",
  "pendingAtClerk": "Junior Clerk",
};


const MISApproval: React.FC = () => {
  const [isChecked, setIsChecked] = useState<boolean>(false);
  const [comment, setComment] = useState<string>("");
  const [checkboxError,setCheckboxError]=useState<string>("");
  const [commentErrors,setCommentErrors]=useState<string>("");
 const [transaction, setTransaction] = useState<any[]>([
   
  ]);
  const [loading, setLoading]=useState<boolean>(false);
  const [uploading, setUploading]=useState<boolean>(false);
  const [modifiedFields, setModifiedFields] = useState<Set<string>>(new Set());
  const [showConfirmModal, setShowConfirmModal] = useState<boolean>(false);
  const [pendingAction, setPendingAction] = useState<{ status: string; appStatusLevel: string; buttonLabel: string } | null>(null);
  
  
  const [applicationData,setApplicationData]=useState<any>([])
  const [buttonData , setButtonData] = useState<any[]>([]);
 const navigate = useNavigate();
  const token=useSelector((state:any)=>state.auth.token)
  const location = useLocation();
  const { applicationId, headerId, headerName } = location.state || {};



  const getDataField = () => {
        const typeNum = headerId;
       
        switch (typeNum) {
          case "f8dd542e-637b-48a9-9579-c51d955958f6":
             
            return MISformP1;
          case "ff834af9-ec91-4b64-be9d-8d6431318d60":
           
            return MISformP2;
          case "03272304-d1c1-4de3-80d5-41cc38d92c4e":
            
            return MISformP3;
          case  "4e3264d9-5849-48c2-adb8-8f365ca9b619":
        
          return MISformP4;
          case "d662fb80-e724-4295-84a7-2335043045e6":
      
            return MISformP5;
          case "4abc0a84-c79c-487e-9459-d5bfda288209":
           
            return MISformP6;
          case "3542455a-a9fe-44cb-b582-bc6645cabd13":
           
            return MISformP7;
            case  "60f185c0-0e2f-45e8-8589-0ee7c5b30720":
           
              return MISformP8;
          case "e8e3723e-fc9c-42a8-8e93-8003fdfa384f":
           
            return MISformP9;
          case "19f2c32b-8727-4c56-bb5f-f2ddab040130":
           
            return MISformP10;
          case "c34fc166-a42d-4c35-9ce7-caf23b63cc38":
         
            return MISformP11;
          case "26d4a5d5-5ca2-4188-8469-1add4e7b798f":
        
            return MISformP12;
          case "03f686ae-0289-4567-abe4-611f054fc460":
          
            return MISformP13;
          case "1be7aa2e-c4b4-4eaf-8a39-714ee69751ca":
             return MISformP14;
          case  "49bb7b6e-2c1d-46c5-90ef-d74d63b323f0":
            return MISformP15;
          case "d3732eaf-9f80-4fc3-8431-e53951c21e2a":
            return MISformP16;
          case "d1ac3935-3f20-4740-9538-f6a641a75496":
            return MISformP17;
          case "5985a467-617e-4feb-a33f-f40f947f2c0e":
            return MISformP18;
          case "f0a5a49e-a89f-4536-88d7-4a5ac74a4a1a":
            return MISformP19;
          case "204d4e1b-e3da-4bea-b011-c00de370ee82":
            return MISformP20;
          case "f1abc58d-2016-477e-92bf-ad2a68c83bc8":
            return MISformP21;
          case "ccbd3a6c-80ec-4d9b-a3a0-ee0461f428a7":
            return MISformP22;
          case "e793e2b8-7f7c-489d-91af-70cbd2af1b3a":
            return MISformP23;
          case "2e9b4f1d-2cd3-4f18-89a3-c1cf54edf005":
            return MISformP24;
          case "cc5c3eda-4bb2-422e-a540-18e3c1e4ff57":
            return MISformP25;
          case "35871e1f-26bc-4c6c-82cd-c5b8be6561f7":
            return MISformP26;
          default:
            return [];
        }
      };
      const misForm = getDataField();
  const fetchApplicationDetails = async () => {
    try {
      setLoading(true);
      const response = await getOneMISApplicationDetails(applicationId, headerId, token);
  
      setApplicationData(response?.data);
setTransaction(response?.data?.transaction || []);
setButtonData(response?.data?.buttonName || []);
  
    
    } catch (error) {
     
    } finally{
      setLoading(false);
    }
  };
  
  useEffect(() => {
    fetchApplicationDetails();
  }, []); 

  useEffect(() => {
  if (transaction.length > 0) {
    const modified = new Set<string>();
    
    transaction.forEach((trans) => {
      // Check reSubmittedFields
      if (trans.reSubmittedFields) {
        const fields = Array.isArray(trans.reSubmittedFields) 
          ? trans.reSubmittedFields 
          : Object.values(trans.reSubmittedFields).filter((f) => f);
        
        fields.forEach((field: any) => {
          const key = `${field.detailId || field.id}-${field.columnName}`;
          modified.add(key);
        });
      }
      
      // Check rejectedFieldName
      if (trans.rejectedFieldName && Array.isArray(trans.rejectedFieldName)) {
        trans.rejectedFieldName.forEach((field: any) => {
          const key = `${field.id}-${field.columnName}`;
          modified.add(key);
        });
      }
    });
    
    setModifiedFields(modified);
  }
}, [transaction]);

const isFieldModified = (detailId: string, columnName: string): boolean => {
  const key = `${detailId}-${columnName}`;
  return modifiedFields.has(key);
};

const handleButtonClick = (status: string, appStatusLevel: string, buttonLabel: string) => {
  // Run validations first
  if (status !== "reject" && !isChecked) {
    setCheckboxError("Please check the declaration before proceeding.");
    toast.error("Please check the declaration before proceeding.", { position: "top-right" });
    return;
  }
  setCheckboxError("");

  if (comment.length <= 0) {
    setCommentErrors("Comment is Required");
    toast.error("Comment is Required", { position: "top-right" });
    return;
  }
  setCommentErrors("");

  // If validations pass, show confirmation modal
  setPendingAction({ status, appStatusLevel, buttonLabel });
  setShowConfirmModal(true);
};

const handleConfirmSubmit = () => {
  if (pendingAction) {
    setShowConfirmModal(false);
    handleSubmit(pendingAction.status, pendingAction.appStatusLevel);
    setPendingAction(null);
  }
};

const handleCancelSubmit = () => {
  setShowConfirmModal(false);
  setPendingAction(null);
};

  
const handleSubmit = async (status: string, appStatusLevel: string) => {
  // Ensure state values are not empty before proceeding
  if (!status || !appStatusLevel && !applicationId) {
    toast.error("Status not found", { position: "top-right" });
    return;
  }

  const formData = {
    headerId: headerId,
    comment: comment,
    status: status,
    appStatusLevel: appStatusLevel,
    applicationId: applicationId,
  }

  try {
    setUploading(true)

    const submitData = await submitApproveRejectMISApplication(formData, token);

    if (submitData.success) {
      if (submitData.data.status === "reject") {
        toast.success("Raised Query Successfully!", { position: "top-right" });
      }
      else {
        toast.success("Report submitted successfully!", { position: "top-right" });
      }
      setTimeout(() => { navigate("/mis-pending-application") }, 1000)
      setButtonData([])
    }
    else {
      toast.error("Submission failed, please try again.", { position: "top-right" });
    }
  }
  catch (error) {
 
    toast.error("An error occurred during submission", { position: "top-right" });
  } finally {
    setUploading(false)
  }
};
 
 
  return (
    <>
    {uploading && (
          <div className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center" style={{background: "rgba(0,0,0,0.3)", zIndex: 1050}}>
            <div className="bg-white p-4 rounded shadow d-flex flex-column align-items-center">
              <div className="spinner-border text-primary mb-3" role="status">
                <span className="visually-hidden">Submitting...</span>
              </div>
              <div className="fw-bold">Submitting, please wait...</div>
            </div>
          </div>
        )}
    {loading?(
      <div className="page-wrapper p-3 mt-5">
    <div className="d-flex justify-content-center align-items-center py-4">
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
</div>
    ):(
        <div className="page-wrapper p-3 mt-5">
        <h3 className="mb-0">
          {headerName}
        </h3>
        <div className="mb-2 d-flex justify-content-end gap-2 align-items-center">
          <div className="rounded" style={{height:"10px", width:"10px", backgroundColor:"#ffe9a0ff"}}></div>
          <p className="fw-bold mb-0">Modified</p>
        </div>
        <div className="mt-4 mb-5">
          <div className="table-responsive">
            <table className="table table-bordered">
              <thead className="table-dark">
                {/* First Header Row */}
                <tr>
                  <th rowSpan={2} style={{ minWidth: "50px", verticalAlign: "middle",border: "1px solid #bcbcbcff", }}>
                    Sr.No.
                  </th>
                  {misForm.map((field, index) => (
                    <th
                      key={index}
                      colSpan={field.response.length > 1 ? field.response.length : undefined}
                      rowSpan={field.response.length === 1 ? 2 : undefined}
                      style={{
                        minWidth: "150px",
                        whiteSpace: "normal",
                        wordWrap: "break-word",
                        textAlign: "center",
                        verticalAlign: "middle",
                        border: "1px solid #bcbcbcff",
                      }}
                    >
                      {field.fieldVal}
                    </th>
                  ))}
                </tr>
               
                {/* Second Header Row - Only for multi-response fields */}
                <tr>
                  {misForm.map((field, fieldIndex) => (
                    <React.Fragment key={fieldIndex}>
                      {field.response.length > 1 && field.response.map((resp, respIndex) => (
                        <th
                          key={respIndex}
                          style={{
                            minWidth: "120px",
                            whiteSpace: "normal",
                            wordWrap: "break-word",
                            textAlign: "center",
                            border: "1px solid #bcbcbcff",
                          }}
                        >
                          {resp.responseName}
                        </th>
                      ))}
                    </React.Fragment>
                  ))}
                </tr>
              </thead>
 
              <tbody>
                {applicationData?.details && applicationData?.details.map((item, index) => (
                  <tr key={item.id}>
                    <td style={{ textAlign: "center" }}>{index + 1}</td>
                    {misForm.map((field, fieldIndex) => (
                      <React.Fragment key={fieldIndex}>
                        {field.response.map((resp, respIndex) => {
                          const isModified = isFieldModified(item.id, resp.fieldName);
                          
                          return (
                            <td
                              key={respIndex}
                              style={{
                                whiteSpace: "normal",
                                wordWrap: "break-word",
                                padding: "0.75rem",
                                backgroundColor: isModified ? "#ffe9a0ff" : "transparent",
                                position: "relative",
                              }}
                              title={isModified ? "This field has been modified" : ""}
                            >
                              <div className="d-flex align-items-center justify-content-between">
                                <span>{item[resp.fieldName as keyof typeof item] || "-"}</span>
                                {isModified && (
                                  <i
                                    className="text-warning ms-2"
                                    style={{ fontSize: "1.1rem" }}
                                  />
                                )}
                              </div>
                            </td>
                          );
                        })}
                      </React.Fragment>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <div className="form-check ">
          <input
            type="checkbox"
            id="declaration"
            className="form-check-input"
            checked={isChecked}
            onChange={() => setIsChecked(!isChecked)}
          />
          <label htmlFor="declaration" className="form-check-label fw-bold">
            I hereby confirm that I have reviewed all the details and that the information has been correctly filled in the report. I approve this for further processing.
          </label>
        </div>
        <div className="mb-5 text-danger fw-bold">
            {checkboxError}
        </div>
        {transaction && transaction.length > 0 && (
          <Link
            to="#"
            data-bs-toggle="modal"
            data-inert={true}
            data-bs-target="#comment_modal"
            className="d-flex btn btn-primary align-items-center w-25 mb-4"
          >
            <i className="me-2 ti ti-file-description" />
            View Application Timeline
          </Link>
        )}
        <textarea
          className="form-control "
          placeholder="Enter your comment"
          name="currAt"
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          rows={4}
        />
        <div className="mb-3 text-danger fw-bold">
            {commentErrors}
        </div>
       <div className="d-flex gap-2">
                        {buttonData.map((button) => (
                          <button
                            key={button.status}
                            className={`btn ${
                              button.status === "reject"
                                ? "btn-danger"
                                :  button.status === "permanentReject" ? "btn-secondary" : "btn-success"
                            } h-10 w-30`}
                            onClick={() => handleButtonClick(button.status, button.appStatusLevel, button.buttonLabel)}
                          >
                            {button.buttonLabel}
                          </button>
                        ))}
                      </div>
      </div>
      )}
      <ApplicationTimelineModal comments={transaction} />
      <ToastContainer position="top-right" autoClose={3000} />
      {/* Confirmation Modal */}
  {showConfirmModal && (
    <div 
      className="modal fade show" 
      style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}
      tabIndex={-1}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Confirm Submission</h5>
            <button 
              type="button" 
              className="btn-close" 
              onClick={handleCancelSubmit}
            />
          </div>
          <div className="modal-body">
  <p className="mb-2">Are you sure you want to forward this Report?</p>
  {pendingAction && (
    <p className="text-muted">
      {pendingAction.appStatusLevel === "clerkAfterApproveAction" ? (
        <strong>This Report will be Approved</strong>
      ) : (
        <>
          This Report will be forwarded to <strong>{APP_STATUS_LEVEL_MAP[pendingAction.appStatusLevel] || pendingAction.appStatusLevel}</strong>
        </>
      )}
    </p>
  )}
</div>
          <div className="modal-footer">
            <button 
              type="button" 
              className="btn btn-secondary me-3" 
              onClick={handleCancelSubmit}
            >
              No
            </button>
            <button 
              type="button" 
              className="btn btn-primary" 
              onClick={handleConfirmSubmit}
            >
              Yes
            </button>
          </div>
        </div>
      </div>
    </div>
  )}
    </>
  );
};
 
export default MISApproval;